import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../supabase';

const statusPorModelo = {
  captacao: [
    { id: 'lead_novo', label: 'Lead Novo', cor: '#3b82f6', bg: '#1e3a5f' },
    { id: 'enviar_orcamento', label: 'Enviar Orçamento', cor: '#a855f7', bg: '#2d1b69' },
    { id: 'orcamento_enviado', label: 'Orçamento Enviado', cor: '#f59e0b', bg: '#3d2800' },
    { id: 'followup1', label: 'Follow Up 1', cor: '#f97316', bg: '#3d1f00' },
    { id: 'followup2', label: 'Follow Up 2', cor: '#ec4899', bg: '#3d0f2a' },
    { id: 'fechado', label: 'Fechado', cor: '#CCFF00', bg: '#1a2600' },
    { id: 'perdido', label: 'Perdido', cor: '#ef4444', bg: '#3d0f0f' },
  ],
  '360': [
    { id: 'novo_lead', label: 'Novo Lead', cor: '#3b82f6', bg: '#1e3a5f' },
    { id: 'em_conversa', label: 'Em Conversa', cor: '#a855f7', bg: '#2d1b69' },
    { id: 'reuniao', label: 'Reunião Agendada', cor: '#f59e0b', bg: '#3d2800' },
    { id: 'proposta', label: 'Proposta Feita', cor: '#f97316', bg: '#3d1f00' },
    { id: 'followup_proposta', label: 'Follow Up de Proposta', cor: '#ec4899', bg: '#3d0f2a' },
    { id: 'fechado', label: 'Fechado', cor: '#CCFF00', bg: '#1a2600' },
    { id: 'perdido', label: 'Perdido', cor: '#ef4444', bg: '#3d0f0f' },
  ],
};

function CRM() {
  const [funis, setFunis] = useState([]);
  const [funilAtivo, setFunilAtivo] = useState(null);
  const [cards, setCards] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [cardSelecionado, setCardSelecionado] = useState(null);
  const [mostrarFormCard, setMostrarFormCard] = useState(false);
  const [mostrarFormFunil, setMostrarFormFunil] = useState(false);
  const [dragging, setDragging] = useState(null);
  const [novoCard, setNovoCard] = useState({ nome: '', empresa: '', contato: '', servico: '', valor_estimado: '', status: '', notas: '' });
  const [novoFunil, setNovoFunil] = useState({ nome: '', descricao: '', modelo: '360' });

  const formatarMoeda = (v) => v ? Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '—';
  const colunas = funilAtivo ? statusPorModelo[funilAtivo.modelo] || statusPorModelo['360'] : [];

  const buscarCards = useCallback(async () => {
    if (!funilAtivo) return;
    setCarregando(true);
    const { data } = await supabase.from('crm_cards').select('*').eq('funil_id', funilAtivo.id).order('criado_em', { ascending: false });
    setCards(data || []);
    setCarregando(false);
  }, [funilAtivo]);

  useEffect(() => { buscarFunis(); }, []);
  useEffect(() => { buscarCards(); }, [buscarCards]);

  const buscarFunis = async () => {
    const { data } = await supabase.from('funis').select('*').order('criado_em');
    setFunis(data || []);
    if (data && data.length > 0) setFunilAtivo(data[0]);
    else setCarregando(false);
  };

  const criarFunil = async () => {
    if (!novoFunil.nome) return;
    const { data } = await supabase.from('funis').insert({
      nome: novoFunil.nome,
      descricao: novoFunil.descricao || null,
      modelo: novoFunil.modelo,
    }).select().single();
    setMostrarFormFunil(false);
    setNovoFunil({ nome: '', descricao: '', modelo: '360' });
    await buscarFunis();
    if (data) setFunilAtivo(data);
  };

  const adicionarCard = async () => {
    if (!novoCard.nome || !funilAtivo) return;
    const primeiroStatus = colunas[0]?.id || 'lead_novo';
    await supabase.from('crm_cards').insert({
      funil_id: funilAtivo.id,
      nome: novoCard.nome,
      empresa: novoCard.empresa || null,
      contato: novoCard.contato || null,
      servico: novoCard.servico || null,
      valor_estimado: novoCard.valor_estimado ? parseFloat(novoCard.valor_estimado) : null,
      status: novoCard.status || primeiroStatus,
      notas: novoCard.notas || null,
    });
    buscarCards();
    setNovoCard({ nome: '', empresa: '', contato: '', servico: '', valor_estimado: '', status: '', notas: '' });
    setMostrarFormCard(false);
  };

  const atualizarCard = async (id, campo, valor) => {
    await supabase.from('crm_cards').update({ [campo]: valor, atualizado_em: new Date().toISOString() }).eq('id', id);
    buscarCards();
    if (cardSelecionado?.id === id) setCardSelecionado(prev => ({ ...prev, [campo]: valor }));
  };

  const removerCard = async (id) => {
    await supabase.from('crm_cards').delete().eq('id', id);
    setCardSelecionado(null);
    buscarCards();
  };

  const onDragStart = (card) => setDragging(card);
  const onDrop = (status) => {
    if (dragging && dragging.status !== status) atualizarCard(dragging.id, 'status', status);
    setDragging(null);
  };

  const totalFechado = cards.filter(c => c.status === 'fechado').reduce((acc, c) => acc + Number(c.valor_estimado || 0), 0);
  const totalPipeline = cards.filter(c => c.status !== 'fechado' && c.status !== 'perdido').reduce((acc, c) => acc + Number(c.valor_estimado || 0), 0);

  return (
    <div className="h-full flex flex-col">
      {/* Cabeçalho */}
      <div className="mb-4 flex justify-between items-center">
        <div>
          <h2 className="text-3xl font-bold text-white">CRM</h2>
          <p className="mt-1 text-sm" style={{ color: '#555' }}>Pipeline de vendas</p>
        </div>
        <div className="flex items-center gap-3">
          {funilAtivo && (
            <div className="flex gap-4 text-sm mr-4">
              <div className="text-center">
                <p className="font-bold" style={{ color: '#CCFF00' }}>{formatarMoeda(totalFechado)}</p>
                <p style={{ color: '#555' }}>Fechado</p>
              </div>
              <div className="text-center">
                <p className="font-bold text-white">{formatarMoeda(totalPipeline)}</p>
                <p style={{ color: '#555' }}>Pipeline</p>
              </div>
            </div>
          )}
          <button onClick={() => setMostrarFormFunil(true)}
            className="px-4 py-2 rounded-xl text-sm font-medium transition-all"
            style={{ backgroundColor: '#1a1a1a', color: '#888', border: '1px solid #2a2a2a' }}>
            + Novo Funil
          </button>
          {funilAtivo && (
            <button onClick={() => setMostrarFormCard(true)}
              className="px-4 py-2 text-black font-semibold rounded-xl text-sm"
              style={{ backgroundColor: '#CCFF00' }}>
              + Nova Oportunidade
            </button>
          )}
        </div>
      </div>

      {/* Tabs de funis */}
      {funis.length > 0 && (
        <div className="flex gap-2 mb-4 overflow-x-auto pb-1">
          {funis.map((funil) => (
            <button key={funil.id}
              onClick={() => setFunilAtivo(funil)}
              className="flex-shrink-0 px-4 py-2 rounded-xl text-sm font-medium transition-all"
              style={{
                backgroundColor: funilAtivo?.id === funil.id ? '#CCFF0020' : '#111',
                color: funilAtivo?.id === funil.id ? '#CCFF00' : '#666',
                border: `1px solid ${funilAtivo?.id === funil.id ? '#CCFF00' : '#1f1f1f'}`,
              }}>
              {funil.nome}
              <span className="ml-2 text-xs opacity-60">{funil.modelo === 'captacao' ? 'Captação' : 'Mkt 360'}</span>
            </button>
          ))}
        </div>
      )}

      {/* Vazio */}
      {funis.length === 0 && (
        <div className="flex-1 flex flex-col items-center justify-center gap-4">
          <p className="text-4xl">🎯</p>
          <h3 className="text-white font-semibold text-xl">Nenhum funil criado ainda</h3>
          <p style={{ color: '#555' }}>Crie seu primeiro funil para começar a organizar suas oportunidades.</p>
          <button onClick={() => setMostrarFormFunil(true)}
            className="px-6 py-3 text-black font-semibold rounded-xl"
            style={{ backgroundColor: '#CCFF00' }}>
            Criar Primeiro Funil
          </button>
        </div>
      )}

      {/* Kanban */}
      {funilAtivo && !carregando && (
        <div className="flex gap-3 overflow-x-auto pb-4 flex-1">
          {colunas.map((col) => {
            const cardsCol = cards.filter(c => c.status === col.id);
            const totalCol = cardsCol.reduce((acc, c) => acc + Number(c.valor_estimado || 0), 0);
            return (
              <div key={col.id} className="flex-shrink-0 w-60 rounded-2xl p-3 flex flex-col"
                style={{ backgroundColor: '#111', border: '1px solid #1f1f1f', minHeight: '400px' }}
                onDragOver={(e) => e.preventDefault()}
                onDrop={() => onDrop(col.id)}>
                <div className="flex justify-between items-center mb-2 px-1">
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full" style={{ backgroundColor: col.cor }}></div>
                    <span className="text-xs font-semibold text-white">{col.label}</span>
                    <span className="text-xs px-1.5 py-0.5 rounded-full" style={{ backgroundColor: col.bg, color: col.cor }}>{cardsCol.length}</span>
                  </div>
                </div>
                {totalCol > 0 && <p className="text-xs px-1 mb-2" style={{ color: '#333' }}>{formatarMoeda(totalCol)}</p>}
                <div className="space-y-2 flex-1">
                    <button
                        onClick={() => { setNovoCard({ ...novoCard, status: col.id }); setMostrarFormCard(true); }}
                        className="w-full py-2 rounded-xl text-xs font-medium transition-all flex items-center justify-center gap-1"
                        style={{ backgroundColor: '#0a0a0a', border: `1px dashed #2a2a2a`, color: '#444' }}
                        onMouseEnter={(e) => { e.target.style.borderColor = col.cor; e.target.style.color = col.cor; }}
                        onMouseLeave={(e) => { e.target.style.borderColor = '#2a2a2a'; e.target.style.color = '#444'; }}
                    >
                        + Adicionar
                    </button>
                  {cardsCol.map((card) => (
                    <div key={card.id} draggable onDragStart={() => onDragStart(card)}
                      onClick={() => setCardSelecionado(card)}
                      className="rounded-xl p-3 cursor-pointer transition-all hover:scale-105"
                      style={{ backgroundColor: '#0a0a0a', border: '1px solid #1f1f1f' }}>
                      <p className="text-white text-sm font-semibold mb-1">{card.nome}</p>
                      {card.empresa && <p className="text-xs mb-1" style={{ color: '#555' }}>{card.empresa}</p>}
                      {card.servico && (
                        <span className="text-xs px-2 py-0.5 rounded-full inline-block mb-1" style={{ backgroundColor: col.bg, color: col.cor }}>{card.servico}</span>
                      )}
                      {card.valor_estimado && (
                        <p className="text-xs font-semibold mt-1" style={{ color: '#CCFF00' }}>{formatarMoeda(card.valor_estimado)}</p>
                      )}
                      {card.notas && <p className="text-xs mt-1 line-clamp-2" style={{ color: '#333' }}>{card.notas}</p>}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Modal novo funil */}
      {mostrarFormFunil && (
        <div className="fixed inset-0 flex items-center justify-center z-50 p-6" style={{ backgroundColor: 'rgba(0,0,0,0.85)' }}
          onClick={() => setMostrarFormFunil(false)}>
          <div className="w-full max-w-md rounded-2xl p-8" style={{ backgroundColor: '#111', border: '1px solid #222' }}
            onClick={(e) => e.stopPropagation()}>
            <h3 className="text-xl font-bold text-white mb-2">Novo Funil</h3>
            <p className="text-sm mb-6" style={{ color: '#555' }}>Cada funil tem um conjunto de etapas específico.</p>
            <div className="space-y-4">
              <div className="flex flex-col gap-1">
                <label className="text-xs font-medium" style={{ color: '#666' }}>Nome do Funil *</label>
                <input type="text" placeholder="Ex: Ads Instagram — Captação" value={novoFunil.nome}
                  onChange={(e) => setNovoFunil({ ...novoFunil, nome: e.target.value })}
                  className="text-white rounded-xl px-3 py-2 text-sm outline-none"
                  style={{ backgroundColor: '#0a0a0a', border: '1px solid #2a2a2a' }} />
              </div>
              <div className="flex flex-col gap-1">
                <label className="text-xs font-medium" style={{ color: '#666' }}>Descrição</label>
                <input type="text" placeholder="Ex: Leads vindos de anúncios no Instagram" value={novoFunil.descricao}
                  onChange={(e) => setNovoFunil({ ...novoFunil, descricao: e.target.value })}
                  className="text-white rounded-xl px-3 py-2 text-sm outline-none"
                  style={{ backgroundColor: '#0a0a0a', border: '1px solid #2a2a2a' }} />
              </div>
              <div className="flex flex-col gap-1">
                <label className="text-xs font-medium mb-2" style={{ color: '#666' }}>Modelo de Funil</label>
                <div className="grid grid-cols-2 gap-3">
                  {[
                    { id: '360', label: 'Marketing 360', desc: 'Com reunião e proposta' },
                    { id: 'captacao', label: 'Captação', desc: 'Orçamento direto' },
                  ].map((m) => (
                    <button key={m.id} onClick={() => setNovoFunil({ ...novoFunil, modelo: m.id })}
                      className="p-4 rounded-xl text-left transition-all"
                      style={{
                        backgroundColor: novoFunil.modelo === m.id ? '#1a2600' : '#0a0a0a',
                        border: `1px solid ${novoFunil.modelo === m.id ? '#CCFF00' : '#2a2a2a'}`,
                      }}>
                      <p className="text-sm font-semibold" style={{ color: novoFunil.modelo === m.id ? '#CCFF00' : '#888' }}>{m.label}</p>
                      <p className="text-xs mt-1" style={{ color: '#444' }}>{m.desc}</p>
                    </button>
                  ))}
                </div>
              </div>
            </div>
            <div className="flex gap-3 mt-6">
              <button onClick={criarFunil}
                className="px-6 py-2.5 text-black font-semibold rounded-xl text-sm"
                style={{ backgroundColor: '#CCFF00' }}>Criar Funil</button>
              <button onClick={() => setMostrarFormFunil(false)}
                className="px-6 py-2.5 rounded-xl text-sm"
                style={{ backgroundColor: '#1a1a1a', color: '#666' }}>Cancelar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal novo card */}
      {mostrarFormCard && (
        <div className="fixed inset-0 flex items-center justify-center z-50 p-6" style={{ backgroundColor: 'rgba(0,0,0,0.85)' }}
          onClick={() => setMostrarFormCard(false)}>
          <div className="w-full max-w-lg rounded-2xl p-8" style={{ backgroundColor: '#111', border: '1px solid #222' }}
            onClick={(e) => e.stopPropagation()}>
            <h3 className="text-xl font-bold text-white mb-1">Nova Oportunidade</h3>
            <p className="text-sm mb-6" style={{ color: '#555' }}>Funil: {funilAtivo?.nome}</p>
            <div className="grid grid-cols-2 gap-4">
              {[
                { label: 'Nome *', key: 'nome', placeholder: 'Nome do contato' },
                { label: 'Empresa', key: 'empresa', placeholder: 'Nome da empresa' },
                { label: 'Contato (tel/email)', key: 'contato', placeholder: 'WhatsApp ou email' },
                { label: 'Serviço', key: 'servico', placeholder: 'Ex: Marketing 360' },
                { label: 'Valor Estimado (R$)', key: 'valor_estimado', type: 'number', placeholder: '0,00' },
              ].map(({ label, key, type = 'text', placeholder }) => (
                <div key={key} className="flex flex-col gap-1">
                  <label className="text-xs font-medium" style={{ color: '#666' }}>{label}</label>
                  <input type={type} placeholder={placeholder} value={novoCard[key]}
                    onChange={(e) => setNovoCard({ ...novoCard, [key]: e.target.value })}
                    className="text-white rounded-xl px-3 py-2 text-sm outline-none"
                    style={{ backgroundColor: '#0a0a0a', border: '1px solid #2a2a2a' }} />
                </div>
              ))}
              <div className="flex flex-col gap-1">
                <label className="text-xs font-medium" style={{ color: '#666' }}>Etapa inicial</label>
                <select value={novoCard.status || colunas[0]?.id}
                  onChange={(e) => setNovoCard({ ...novoCard, status: e.target.value })}
                  className="text-white rounded-xl px-3 py-2 text-sm outline-none"
                  style={{ backgroundColor: '#0a0a0a', border: '1px solid #2a2a2a' }}>
                  {colunas.map(c => <option key={c.id} value={c.id}>{c.label}</option>)}
                </select>
              </div>
            </div>
            <div className="flex flex-col gap-1 mt-4">
              <label className="text-xs font-medium" style={{ color: '#666' }}>Notas</label>
              <textarea rows={3} placeholder="Anotações sobre essa oportunidade..." value={novoCard.notas}
                onChange={(e) => setNovoCard({ ...novoCard, notas: e.target.value })}
                className="text-white rounded-xl px-3 py-2 text-sm outline-none resize-none"
                style={{ backgroundColor: '#0a0a0a', border: '1px solid #2a2a2a' }} />
            </div>
            <div className="flex gap-3 mt-6">
              <button onClick={adicionarCard}
                className="px-6 py-2.5 text-black font-semibold rounded-xl text-sm"
                style={{ backgroundColor: '#CCFF00' }}>Salvar</button>
              <button onClick={() => setMostrarFormCard(false)}
                className="px-6 py-2.5 rounded-xl text-sm"
                style={{ backgroundColor: '#1a1a1a', color: '#666' }}>Cancelar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal edição card */}
      {cardSelecionado && (
        <div className="fixed inset-0 flex items-center justify-center z-50 p-6" style={{ backgroundColor: 'rgba(0,0,0,0.85)' }}
          onClick={() => setCardSelecionado(null)}>
          <div className="w-full max-w-lg rounded-2xl p-8" style={{ backgroundColor: '#111', border: '1px solid #222' }}
            onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-start mb-6">
              <input className="text-2xl font-bold text-white bg-transparent border-b outline-none pb-1 flex-1"
                style={{ borderColor: '#333' }}
                defaultValue={cardSelecionado.nome}
                onBlur={(e) => atualizarCard(cardSelecionado.id, 'nome', e.target.value)} />
              <button onClick={() => setCardSelecionado(null)} className="ml-4 text-xl" style={{ color: '#444' }}>✕</button>
            </div>
            <div className="grid grid-cols-2 gap-4 mb-4">
              {[
                { label: 'Empresa', campo: 'empresa' },
                { label: 'Contato', campo: 'contato' },
                { label: 'Serviço', campo: 'servico' },
                { label: 'Valor Estimado', campo: 'valor_estimado', type: 'number' },
              ].map(({ label, campo, type = 'text' }) => (
                <div key={campo} className="flex flex-col gap-1">
                  <label className="text-xs uppercase tracking-wide" style={{ color: '#444' }}>{label}</label>
                  <input type={type} defaultValue={cardSelecionado[campo] || ''}
                    onBlur={(e) => atualizarCard(cardSelecionado.id, campo, type === 'number' ? parseFloat(e.target.value) : e.target.value)}
                    className="text-white rounded-xl px-3 py-2 text-sm outline-none"
                    style={{ backgroundColor: '#0a0a0a', border: '1px solid #2a2a2a' }} />
                </div>
              ))}
            </div>
            <div className="flex flex-col gap-2 mb-4">
              <label className="text-xs uppercase tracking-wide" style={{ color: '#444' }}>Etapa</label>
              <div className="flex flex-wrap gap-2">
                {colunas.map(col => (
                  <button key={col.id}
                    onClick={() => { atualizarCard(cardSelecionado.id, 'status', col.id); setCardSelecionado(prev => ({...prev, status: col.id})); }}
                    className="px-3 py-1.5 rounded-lg text-xs font-medium transition-all"
                    style={{
                      backgroundColor: cardSelecionado.status === col.id ? col.bg : '#0a0a0a',
                      color: cardSelecionado.status === col.id ? col.cor : '#444',
                      border: `1px solid ${cardSelecionado.status === col.id ? col.cor : '#1f1f1f'}`
                    }}>
                    {col.label}
                  </button>
                ))}
              </div>
            </div>
            <div className="flex flex-col gap-1 mb-6">
              <label className="text-xs uppercase tracking-wide" style={{ color: '#444' }}>Notas</label>
              <textarea rows={4} defaultValue={cardSelecionado.notas || ''}
                onBlur={(e) => atualizarCard(cardSelecionado.id, 'notas', e.target.value)}
                className="text-white rounded-xl px-3 py-2 text-sm outline-none resize-none"
                style={{ backgroundColor: '#0a0a0a', border: '1px solid #2a2a2a' }} />
            </div>
            <div className="flex justify-between pt-4" style={{ borderTop: '1px solid #1a1a1a' }}>
              <button onClick={() => removerCard(cardSelecionado.id)}
                className="px-4 py-2 rounded-xl text-sm"
                style={{ backgroundColor: 'rgba(239,68,68,0.1)', color: '#ef4444' }}>Remover</button>
              <button onClick={() => setCardSelecionado(null)}
                className="px-6 py-2 text-black font-semibold rounded-xl text-sm"
                style={{ backgroundColor: '#CCFF00' }}>Fechar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CRM;